export const LocationFragment = /* GraphQL */ `
	fragment LocationFragment on Location {
		_id
		created_at
		updated_at
		venue
		name
		type
		payment_types
		status
		hash
		no_vat
		no_service_charge
		is_pay_later_allowed
		is_pay_now_allowed
		locations_groups_tags
		room_number
		default_order_note
		hidden_items_configs {
			items
			item_types
			categories
			is_items_hide_on_qr
			is_categories_hide_on_qr
			is_item_types_hide_on_qr
		}
	}
`;
